// extracted by mini-css-extract-plugin
export default {"shadow-batch-modal":"shadow-batch-modal","shadow-required-body":"shadow-required-body","shadow-required-message":"shadow-required-message","shadow-pending-btn":"shadow-pending-btn"};